import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import * as moment from "moment";
import {confirmAlert} from 'react-confirm-alert';
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import TxnTypeFilter from '../../filters/TxnTypeFilter1.jsx';
import SettledUnsettledFilter from '../../filters/settled_unsettledFilter.jsx';
import { isApiResponse, isReportAccess, date_range_config, reactSelectStyles,user_activities } from '../../helpers/utils.js';
import SingleCsvReportDownload from '../DownloadReport/SingleCsvReportDownload.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import IndustryCategoryFilter from '../../filters/IndustryCategoryFilter.jsx';
import PosbillFilter from '../../filters/PosbillFilter.jsx';
import PrimIdFilter from '../../filters/PrimIdFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('1', '1', '2020-02-01','1');
var date_config1 = date_range_config('0', '0', '2020-02-01','0');
class PhonePeTransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            cityIds:'',
            loading:false,
            is_void:1,
            txnTypeIDs: ['SALE'],
            ciutidIds: '',
            isSettledIDs: '',
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            industryCategoryIds:'',
            txnLists:[{value:'Leg1 QR Transaction', label: 'Leg1'},{value:'Leg2 QR Transaction', label: 'Leg2'}],
            txnValue:'',
            txnIds:'',
            is_current_date: 'yes'
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'phonePe_transaction');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }
    componentDidUpdate() {

    }
    componentDidMount() {
       this.get_filtered_phonepe_transaction_report(this.state.object_type,this.state.object_code,'');
       user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'phonePe_txn_report','sparcs')
    }


    get_filtered_phonepe_transaction_report(object_type, object_code, event) {
        var that = this;
        var corCol = 'Merchant';
        var ufeCol = 'Merchant';
        var CI_Time = 'Merchant'; var BI_Time = 'Merchant'; var BO_Time = 'Merchant'; var CO_Time = 'Merchant';
        if(this.state.userType==='Internal') {
            CI_Time = 'CI Time'; BI_Time = 'BI Time'; BO_Time = 'BO Time'; CO_Time = 'CO Time';
        }
        if(that.state.txnTypeIDs.includes("FAILED")===true || that.state.txnTypeIDs.includes("all")===true) {
            corCol = 'Co Reason Message';
            ufeCol = 'Ufe Message';
        }
        var pos_order_id = 'Merchant';
        var grab_order_id = 'Merchant';
        var grab_client_id = 'Merchant';
        var pos_merchant = 'Merchant';
        if(that.state.is_posbillinput==1){
            grab_order_id = 'Grab Order ID';
            pos_order_id = 'Pos Order ID';
            grab_client_id = 'Grab Client ID';
            pos_merchant = 'Pos Merchant ID';
        }

        isApiResponse(false);
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        var yestSend = date_config1.start_date_value;
        var todSend = date_config1.end_date_value;
        if(this.state.is_current_date=='no') {
            yestSend = this.state.yestSend;
            todSend = this.state.todSend;
        }
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: yestSend,
            todSend: todSend,
            is_void: 1,
            txnIds: this.state.txnIds,
            txn_type: 'PHONE_PE',
            transaction_type: this.state.txnTypeIDs,
            utid: this.state.ciutidIds,
            is_settled: this.state.isSettledIDs,
            is_posbillinput: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            industry_code: this.state.industryCategoryIds,
            userType: this.state.userType,
            is_current_date: this.state.is_current_date
        };
        if ($.fn.DataTable.isDataTable('#phonePeTraTable')) {
            $('#phonePeTraTable').DataTable().clear().destroy();
        }
        var phonePeTraTable = $('#phonePeTraTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/transaction-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"Merchant", "width":"100px" },
                    {"data":"Chain", "width":"100px" },
                    {"data":"Store Name", "width":"100px"},
                    {"data":"Store Address 1", "width":"100px"},
                    {"data":"Store Address 2", "width":"10px"},
                    {"data":"City"},
                    // {"data": "Acquirer Bank"},
                    {"data":"Merchant Id"},
                    {"data":"PhonePe Merchant Id"},
                    {"data":"Store Id"},
                    {"data":"Utid"},
                    {"data":"Invoice Number"},
                    {"data":"Transaction Date"},
                    {"data":"Transaction Time"},
                    {"data":"Txn ID"},
                    {"data":"PhonePe Txn Id"},
                    {"data":"Invoice Amount"},
                    {"data":"Debit Amount"},
                    {"data":"Processing Code"},
                    {"data":"Txn Type"},
                    {"data":"Payment Code"},
                    {"data":"Message"},
                    {"data":"Front End App Version"},
                    {"data":"Settlement Date"},
                    {"data":"Settled/Unsettled"},
                    {"data":corCol},
                    {"data":ufeCol},
                    {"data":grab_order_id },
                    {"data":pos_order_id },
                    {"data":grab_client_id },
                    {"data":pos_merchant },
                    {"data":"prim_id" },
                    {"data":"parent_prim_id"},
                    {"data":"State"},
                    {"data":"Industry Category"},
                    {"data":CI_Time },
                    {"data":BI_Time },
                    {"data":BO_Time },
                    {"data":CO_Time }

                ],
                "columnDefs": [
                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                        },
                        "width": "80px",
                        "targets": 11
                    },
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [0,1,2,3,4]
                    },

                ],

            });
        if(that.state.userType==='Internal') {
            phonePeTraTable.columns(35).visible(true);
            phonePeTraTable.columns(36).visible(true);
            phonePeTraTable.columns(37).visible(true);
            phonePeTraTable.columns(34).visible(true);
        } else {
            phonePeTraTable.columns(35).visible(false);
            phonePeTraTable.columns(36).visible(false);
            phonePeTraTable.columns(37).visible(false);
            phonePeTraTable.columns(34).visible(false);
        }
        if(that.state.txnTypeIDs.includes("FAILED")===true || that.state.txnTypeIDs.includes("all")===true) {
            phonePeTraTable.columns(24).visible(true);
            phonePeTraTable.columns(25).visible(true);
        } else {
            phonePeTraTable.columns(24).visible(false);
            phonePeTraTable.columns(25).visible(false);
        }
        if(that.state.is_posbillinput===1) {
            phonePeTraTable.columns(26).visible(true);
            phonePeTraTable.columns(27).visible(true);
            phonePeTraTable.columns(28).visible(true);
            phonePeTraTable.columns(29).visible(true);
        } else {
            phonePeTraTable.columns(26).visible(false);
            phonePeTraTable.columns(27).visible(false);
            phonePeTraTable.columns(28).visible(false);
            phonePeTraTable.columns(29).visible(false);
        }
        if(that.state.is_prim_id===1) {
            phonePeTraTable.columns(30).visible(true);
            if(that.state.txnTypeIDs.includes("REVERSAL")===true || that.state.txnTypeIDs.includes("VOID")===true || that.state.txnTypeIDs.includes("FAILED")===true|| that.state.txnTypeIDs.includes("all")===true) {
                phonePeTraTable.columns(31).visible(true);
            } else {
                phonePeTraTable.columns(31).visible(false);
            }
        } else {
            phonePeTraTable.columns(30).visible(false);
            phonePeTraTable.columns(31).visible(false);
        }
    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList,
                    is_merchant_loading: false
                })
            }

        });
    }


    transactionReportDownloadCheck(){
        let transaction_type = this.state.txnTypeIDs;
        if (Array.isArray(this.state.txnTypeIDs) && this.state.txnTypeIDs.includes("all") === true) {
            transaction_type = ""
        }
        if(this.state.txnTypeIDs.includes("UPI Leg1")===true) {
            transaction_type = ["UPI Leg1 Sale"];
        }
        var yestSend = date_config1.start_date_value;
        var todSend = date_config1.end_date_value;
        if(this.state.is_current_date=='no') {
            yestSend = this.state.yestSend;
            todSend = this.state.todSend;
        }
        var filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            acq_bank_codes: this.state.acqBankIds,
            city: this.state.cityIds,
            start_date: yestSend,
            end_date: todSend,
            show_void_transactions: this.state.is_void,
            download: 1,
            txn_type: 'PHONE_PE',
            transaction_type: transaction_type,
            utid: this.state.ciutidIds,
            settlement_status: this.state.isSettledIDs,
            show_pos_bill_input_columns: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            category_code: this.state.industryCategoryIds,
            phonepe_txn_type: this.state.txnIds,
            gst_columns:0,
            user_type: this.state.userType,
            report_code:"phonepay_txn_report",
            user_id: this.state.user_id,
            is_current_date: this.state.is_current_date
        };
    let is_txn = false;
    if(this.state.txnTypeIDs.length===1 && this.state.txnTypeIDs[0]==='SALE')
    {
       is_txn = true;
    }
    if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds==='' && this.state.txnIds===''
    && this.state.cityIds==='' && this.state.isSettledIDs==='' && is_txn ===true
    ){
      confirmAlert({
            //title: 'Warning',
            message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
            buttons: [{
                label: 'OK',
                onClick: () => {
                    this.refs.downloadAllReport.downLoadReport(filters, '/report/transaction/daily/categories','phonePe_pay_transaction_report');
                }
            },
                {
                    label: 'Cancel',
                }
            ]
        });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/report/transaction/daily/categories','phonePe_pay_transaction_report');
        }
    }

    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });


    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }
    handleIndustryCategoryFilter = (optionSelected, industryCategoryIds) =>
    {
        this.setState({
            industryCategoryIds:industryCategoryIds,
            isChange: true
        });
    }
    handleTxnType = (optionSelected, txnTypeIDs) =>
    {
        this.setState({
            txnTypeIDs:txnTypeIDs,
            txnTypeValue:optionSelected,
            isChange: true
        });
    }

    handleSettled = (optionSelected, isSettledIDs) =>
    {
        this.setState({
            isSettledIDs:isSettledIDs,
            isSettledValue:optionSelected,
            isChange: true
        });
    }
    change_txn(optionSelected)
    {
        let value='';
        let txnArray = [];
        if(optionSelected.length < 1){
            value = null;
            txnArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                txnArray.push(mids.value)
                var index = this.state.txnLists.findIndex(obj => obj.value==mids.value);
                this.state.txnLists.move(index,0).join(',');
            });
        }

        this.setState({
            txnIds:txnArray,
            txnValue:optionSelected,
            isChange: true
        });
    }
    handlePosBill = (is_posbillinput) => {
        this.setState({is_posbillinput: is_posbillinput, isChange: true});
    }
    handlePrimId = (is_prim_id) => {
        this.setState({is_prim_id: is_prim_id, isChange: true});
    }
    reset_all(e){
          if(this.state.is_current_date=='no'){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        }
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
        this.refs.txnTypeFilter.resetTxnTypeFilter();
        this.refs.settledFilter.resetSettledFilter();
        this.refs.posbillFilter.resetPosbillFilter();
        this.refs.primIdFilter.resetPrimIdFilter();
        this.refs.industryCategoryFilter.resetIndustryCategoryFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            is_void:1,
            txnTypeIDs: ['SALE'],
            ciutidIds: '',
            isSettledIDs: '',
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            industryCategoryIds:'',
            txnIds:'',
            txnValue:[],
            is_current_date:'yes'

        })

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);

    }
    onDateTypeChanged = e => {
        const {name, value} = e.target;
        this.setState({
            [name]: value,
            isChange: true,

        });

    }
    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">PhonePe Transaction Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content" style={{ padding: '0px 15px 10px 15px' }}>
                                    <div className="row">
                                        <div className="col-md-10 filter-border-right">
                                            <div>
                                                <label><input type="radio" name="is_current_date"
                                                                   value="yes"
                                                                   checked={this.state.is_current_date === 'yes'}
                                                                   onChange={this.onDateTypeChanged} /> Current Date
                                                                   &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" name="is_current_date"
                                                                   value="no"
                                                                   checked={this.state.is_current_date === 'no'}
                                                                   onChange={this.onDateTypeChanged} /> Previous Date</label>

                                                </div>
                                                <div className="clearfix"></div>
                                                {this.state.is_current_date==='no'?
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>:null}
                                            {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>PhonePe Txn Type</label>
                                                <ReactMultiSelectCheckboxes name="txn_type"
                                                    isMulti
                                                    value={this.state.txnValue}
                                                     styles={reactSelectStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.change_txn.bind(this)}
                                                    options={this.state.txnLists}
                                                    placeholderButtonLabel="Select [Txn Type]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>


                                        <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Txn Type </label>
                                                <TxnTypeFilter ref="txnTypeFilter" onSelectTxnType = {this.handleTxnType} is_upi_leg1 = 'Yes' />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Settled/Unsettled </label>
                                                <SettledUnsettledFilter ref="settledFilter" onSelectSettled = {this.handleSettled}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Industry Category: </label>
                                                <IndustryCategoryFilter ref="industryCategoryFilter" onSelectIndustryCategoryFilter = {this.handleIndustryCategoryFilter}/>
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                        <div className="col-md-2 filter-bottom5 ">
                                             <div>
                                                <PosbillFilter ref="posbillFilter" onSelectPosbill = {this.handlePosBill} />
                                            </div>
                                            <div>
                                                <PrimIdFilter ref="primIdFilter" onSelectPrimId = {this.handlePrimId} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_phonepe_transaction_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.transactionReportDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="phonePeTraTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th width="100px">Merchant</th>
                                                    <th width="100px">Chain</th>
                                                    <th width="100px">Store Name</th>
                                                    <th width="150px">Store Address 1</th>
                                                    <th>Store Address 2</th>
                                                    <th>City</th>
                                                    {/*<th>Acquirer Bank</th>*/}
                                                    <th>Merchant Id</th>
                                                    <th>PhonePe Merchant Id</th>
                                                    <th>Store Id</th>
                                                    <th>UTID</th>
                                                    <th>Invoice Number</th>
                                                    <th>Transaction Date</th>
                                                    <th>Transaction Time</th>
                                                    <th>Txn ID</th>
                                                    <th>PhonePe Txn Id</th>
                                                    <th>Invoice Amount</th>
                                                    <th>Debit Amount</th>
                                                    <th>Processing Code</th>
                                                    <th>Txn Type</th>
                                                    <th>Payment Code</th>
                                                    <th>Message</th>
                                                    <th>Front End App Version</th>
                                                    <th>Settlement Date</th>
                                                    <th>Settled/Unsettled</th>
                                                    <th>Co Reason Message</th>
                                                    <th>Ufe Message</th>
                                                    <th>Grab Order ID</th>
                                                    <th>Pos Order ID</th>
                                                    <th>Grab Client ID</th>
                                                    <th>Pos Merchant ID</th>
                                                    <th>Prim ID</th>
                                                    <th>Parent Prim ID</th>
                                                    <th>State</th>
                                                    <th>Industry Category</th>
                                                    <th>CI Time</th>
                                                    <th>BI Time</th>
                                                    <th>BO Time</th>
                                                    <th>CO Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <SingleCsvReportDownload ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( PhonePeTransactionReport );